import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Checkbox,
  Divider,
  Upload,
  message,
  Tabs,
  Card,
  Tooltip,
  Spin,
  Table,
  Badge,
  Tag,
  Modal,
  Skeleton,
  Select,
  Image
} from "antd";
import {
  UserOutlined,
  MailOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
  LinkOutlined,
  CloudUploadOutlined,
  LoadingOutlined,
  PlusOutlined,
  LockOutlined,
  FacebookFilled,
  InstagramOutlined,
  LinkedinFilled,
  EyeOutlined,
  InboxOutlined,
  DeleteOutlined,
  PictureOutlined,
  TagOutlined,
  FolderOutlined,
  CompassOutlined,
  PlayCircleFilled,
  VideoCameraOutlined,
  FileTextOutlined,
  UploadOutlined,
  CheckCircleFilled,
  CheckCircleOutlined,
  ClockCircleOutlined,
  SafetyCertificateOutlined,
  DragOutlined,
  HolderOutlined,
  ProjectOutlined
} from "@ant-design/icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import ButtonBar from "../../components/ButtonNavigation";
import * as TrustedDealerService from "../../services/TrustedDealer";
import PagesHeader from "../../components/PageHeader";
import * as UserDataService from '../../services/GetUserData';
import * as Actions from '../../store/actions/user';
import { MEDIA_UPLOAD_URL, INSPECTION_URL, WEBSITE_URL } from "../../Helper";
import TrustedDealerCocGuard from "../../components/TrustedDealerCocGuard";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy,
  useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";
import {
  align,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  lineHeight,
  list,
  paragraphStyle,
  table,
  template,
  textStyle,
  link
} from "suneditor/src/plugins";

const SunEditorOpts = {
  showPathLabel: false,
  height: "auto",
  minHeight: "220px",
  plugins: [
    align,
    font,
    fontColor,
    fontSize,
    formatBlock,
    hiliteColor,
    horizontalRule,
    lineHeight,
    list,
    paragraphStyle,
    table,
    template,
    textStyle,
    link
  ],
  buttonList: [
    ["undo", "redo"],
    ["font", "fontSize", "formatBlock"],
    ["paragraphStyle"],
    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
    ["fontColor", "hiliteColor"],
    ["removeFormat"],
    ["outdent", "indent"],
    ["align", "horizontalRule", "list", "lineHeight"],
    ["table", "link"],
    ["fullScreen", "showBlocks", "codeView"]
  ]
};

const { TextArea } = Input;
const { TabPane } = Tabs;

// Sortable gallery card for inline drag-and-drop reorder
const SortableGalleryCard = ({ img, index, isVideo, posterUrl, isPremium, onPreview, onPlayVideo, onDelete, onCategoryChange }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: String(img.id) });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 1,
  };

  return (
    <Col xs={24} sm={12} md={8} ref={setNodeRef} style={style}>
      <Card 
        className="videocard-box gallery-photo-card"
        hoverable
        style={{ 
          borderRadius: '16px', 
          overflow: 'hidden', 
          border: isDragging ? '2px solid #1890ff' : (isVideo ? '1px solid #fecaca' : '1px solid #e2e8f0'), 
          boxShadow: isDragging ? '0 16px 40px rgba(24, 144, 255, 0.3)' : '0 10px 25px -5px rgba(15, 23, 42, 0.08), 0 8px 10px -6px rgba(15, 23, 42, 0.04)',
          background: '#ffffff',
          transition: 'all 0.2s ease',
          cursor: isDragging ? 'grabbing' : 'default',
        }}
        cover={
          <div style={{ position: 'relative', height: '220px', background: '#0f172a', overflow: 'hidden' }}>
            <style dangerouslySetInnerHTML={{__html: `
              .gallery-photo-card .image-overlay {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(15, 23, 42, 0.42) !important;
                backdrop-filter: blur(2px) !important;
                opacity: 0;
                transition: opacity 0.2s ease-in-out !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 16px;
                z-index: 10;
              }
              .gallery-photo-card:hover .image-overlay {
                opacity: 1 !important;
              }
              .overlay-action-btn {
                width: 46px;
                height: 46px;
                border-radius: 50% !important;
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                border: 1.5px solid rgba(255, 255, 255, 0.5) !important;
                background: rgba(15, 23, 42, 0.65) !important;
                backdrop-filter: blur(8px) !important;
                color: #ffffff !important;
                font-size: 20px !important;
                cursor: pointer;
                transition: all 0.2s ease-in-out !important;
                box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3) !important;
              }
              .overlay-action-btn:hover {
                background: #ffffff !important;
                color: #0284c7 !important;
                border-color: #ffffff !important;
                transform: scale(1.15);
                box-shadow: 0 8px 22px rgba(0,0,0,0.35) !important;
              }
              .overlay-action-btn.delete-btn:hover {
                background: #ef4444 !important;
                color: #ffffff !important;
                border-color: #ef4444 !important;
                box-shadow: 0 8px 22px rgba(239, 68, 68, 0.45) !important;
              }
            `}} />
            {isVideo ? (
              posterUrl ? (
                <img src={posterUrl} alt="Video Poster" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <video src={img.url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} muted preload="metadata" />
              )
            ) : (
              <img src={img.url} alt="Gallery photo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            )}

            {/* Blue Index Badge - top left */}
            <div style={{
              position: 'absolute',
              top: 10,
              left: 10,
              background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)',
              color: '#ffffff',
              minWidth: '32px',
              height: '32px',
              padding: '0 8px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '13px',
              fontWeight: '800',
              zIndex: 12,
              boxShadow: '0 4px 12px rgba(2, 132, 199, 0.4)',
              border: '1.5px solid rgba(255, 255, 255, 0.85)',
              letterSpacing: '0.5px'
            }}>
              {index + 1}
            </div>

            {/* Glassmorphic Drag Handle Icon - top right */}
            <div
              {...attributes}
              {...listeners}
              style={{
                position: 'absolute',
                top: 10,
                right: 10,
                zIndex: 15,
                background: 'rgba(15, 23, 42, 0.8)',
                backdropFilter: 'blur(8px)',
                color: '#ffffff',
                width: '34px',
                height: '34px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'grab',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                transition: 'all 0.2s ease',
              }}
              title="Click and drag to rearrange photo"
            >
              <DragOutlined style={{ fontSize: 16, color: '#ffffff' }} />
            </div>

            {/* Video Badge - bottom right */}
            {isVideo && (
              <div style={{ position: 'absolute', bottom: 10, right: 10, zIndex: 12 }}>
                <span style={{ 
                  background: 'linear-gradient(135deg, #e11d48 0%, #be123c 100%)', 
                  color: '#ffffff', 
                  padding: '4px 10px', 
                  borderRadius: 20, 
                  fontWeight: 700, 
                  fontSize: 10.5, 
                  letterSpacing: '0.5px',
                  boxShadow: '0 4px 12px rgba(225, 29, 72, 0.4)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 4
                }}>
                  <PlayCircleFilled style={{ fontSize: 12 }} /> VIDEO
                </span>
              </div>
            )}

            {/* Album / Category Badge - bottom left */}
            {isPremium && (
              <div style={{ position: 'absolute', bottom: 10, left: 10, zIndex: 12 }}>
                <span style={{ 
                  background: 'rgba(15, 23, 42, 0.85)', 
                  backdropFilter: 'blur(8px)',
                  color: '#ffffff', 
                  padding: '4px 12px', 
                  borderRadius: 20, 
                  fontWeight: 600, 
                  fontSize: 11, 
                  border: '1px solid rgba(255, 255, 255, 0.2)', 
                  boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 4
                }}>
                  {img.category ? `🏷️ ${img.category}` : "Uncategorized"}
                </span>
              </div>
            )}

            {/* Hover Glassmorphic Overlay with Preview & Delete buttons */}
            <div className="image-overlay">
              <Tooltip title={isVideo ? "Play Video Preview" : "Preview Full Photo Gallery"}>
                <button 
                  type="button" 
                  className="overlay-action-btn" 
                  onClick={(e) => {
                    e.stopPropagation();
                    if (isVideo) {
                      onPlayVideo(img);
                    } else {
                      onPreview(img);
                    }
                  }}
                >
                  {isVideo ? <PlayCircleFilled /> : <EyeOutlined />}
                </button>
              </Tooltip>

              <Tooltip title="Delete Item">
                <button 
                  type="button" 
                  className="overlay-action-btn delete-btn" 
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(img.id);
                  }}
                >
                  <DeleteOutlined />
                </button>
              </Tooltip>
            </div>
          </div>
        }
      >
        <div style={{ padding: '6px 2px 4px' }}>
          <div style={{ fontSize: '11px', fontWeight: 700, color: isPremium ? '#475569' : '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: 6, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              {isPremium ? <TagOutlined style={{ color: '#0a497b' }} /> : <LockOutlined style={{ color: '#d97706' }} />} Album / Category Tag
            </span>
            {!isPremium && <span style={{ color: '#d97706', fontSize: '10px', textTransform: 'none', fontWeight: 700 }}>🔒 Premium Feature</span>}
          </div>
          <Tooltip title={!isPremium ? "Custom photo album & category tagging is available on Premium plan." : ""}>
            <Input 
              prefix={isPremium ? <FolderOutlined style={{ color: '#94a3b8' }} /> : <LockOutlined style={{ color: '#d97706' }} />}
              placeholder={isPremium ? "e.g. Showroom Displays" : "🔒 Available on Premium Plan"} 
              value={isPremium ? (img.category || '') : ''} 
              disabled={!isPremium}
              onChange={(e) => {
                if (!isPremium) return;
                onCategoryChange(img.id, e.target.value);
              }}
              size="middle"
              style={{ borderRadius: 8, fontSize: 13, borderColor: isPremium ? '#cbd5e1' : '#e2e8f0', background: isPremium ? '#fff' : '#f8fafc', cursor: isPremium ? 'text' : 'not-allowed' }}
            />
          </Tooltip>
        </div>
      </Card>
    </Col>
  );
};

function TrustedDealerDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);
  
  // User context
  const currentUser = useSelector((state) => state.user?.userData);
  const [profileRole, setProfileRole] = useState("");
  const [isPremium, setIsPremium] = useState(false);
  const profileId = currentUser?.inspector_id; // Linked CPT post ID (mapped through get_current_userdata_api)
  const [currentProfileId, setCurrentProfileId] = useState(profileId || 0);

  // Profile data states
  const [aboutMe, setAboutMe] = useState("");
  const [profilePicUrl, setProfilePicUrl] = useState("");
  const [profilePicId, setProfilePicId] = useState(0);
  const [loadingProfilePic, setLoadingProfilePic] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const [logoId, setLogoId] = useState("");
  const [loadingLogo, setLoadingLogo] = useState(false);
  const [coverUrl, setCoverUrl] = useState("");
  const [coverId, setCoverId] = useState("");
  const [loadingCover, setLoadingCover] = useState(false);
  const [gallery, setGallery] = useState([]);
  const [galleryIds, setGalleryIds] = useState([]);

  // Custom Services & Brands (Premium Max 5)
  const [customServices, setCustomServices] = useState([]);
  const [customBrands, setCustomBrands] = useState([]);
  const [newServiceInput, setNewServiceInput] = useState("");
  const [newBrandInput, setNewBrandInput] = useState("");

  // Inquiry management states
  const [inquiries, setInquiries] = useState([]);
  const [inquiryLoading, setInquiryLoading] = useState(false);
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [inquiryModalVisible, setInquiryModalVisible] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  // Code of Conduct states
  const [cocData, setCocData] = useState(null);
  const [cocModalVisible, setCocModalVisible] = useState(false);
  const [cocAgreeLoading, setCocAgreeLoading] = useState(false);
  const [previewCocModalVisible, setPreviewCocModalVisible] = useState(false);

  useEffect(() => {
    // Fetch logged in user details first
    dispatch(UserDataService.getUserData())
      .then((res) => {
        dispatch(Actions.set_user_auth(res));
        const queryParams = new URLSearchParams(window.location.search);
        const dealerIdParam = queryParams.get('dealer_id') || queryParams.get('inspector_id');
        const pId = dealerIdParam ? parseInt(dealerIdParam, 10) : (res?.inspector_id || (res?.profiles && res?.profiles[0]?.ID) || profileId || 0);
        setCurrentProfileId(pId);
        fetchProfileData(pId);
        fetchInquiries(pId);
      })
      .catch((err) => {
        const queryParams = new URLSearchParams(window.location.search);
        const dealerIdParam = queryParams.get('dealer_id') || queryParams.get('inspector_id');
        const pId = dealerIdParam ? parseInt(dealerIdParam, 10) : (profileId || 0);
        fetchProfileData(pId);
        fetchInquiries(pId);
      });
  }, []);

  const fetchProfileData = (targetId = 0) => {
    setLoading(true);
    const pId = targetId || currentProfileId || profileId || 0;
    dispatch(TrustedDealerService.getTrustedDealerProfileData(pId))
      .then((res) => {
        if (res) {
          const profileData = (res && res.data && typeof res.data === 'object' && !res.profile_id) ? res.data : res;

          if (profileData.profile_id) {
            setCurrentProfileId(profileData.profile_id);
          }
          if (profileData.user_role) {
            setProfileRole(profileData.user_role);
          }
          const isPrem = profileData.is_premium !== undefined ? !!profileData.is_premium : false;
          setIsPremium(isPrem);
          setAboutMe(profileData.about_me || "");
          setProfilePicUrl(profileData.profile_pic || "");
          setProfilePicId(profileData.profile_pic_id || profileData.thumbnail_id || 0);
          setLogoUrl(profileData.logo_url || "");
          setLogoId(profileData.logo_id || "");
          setCoverUrl(profileData.cover_url || "");
          setCoverId(profileData.cover_id || "");
          const rawGallery = profileData.gallery || [];
          const cappedGallery = !isPrem ? rawGallery.slice(0, 3) : rawGallery;
          setGallery(cappedGallery);
          setGalleryIds(cappedGallery.map(g => g.id));
          
          form.setFieldsValue({
            organization_name: profileData.organization_name || "",
            address: profileData.address || "",
            phone_number: profileData.phone_number || "",
            email: profileData.email || "",
            website: profileData.website || "",
            years_in_business: profileData.years_in_business || "",
            service_radius: profileData.service_radius || "50",
            license_number: profileData.license_number || "",
            insurance_policy: profileData.insurance_policy || "",
            linkedin: profileData.linkedin || "",
            instagram: profileData.instagram || "",
            facebook: profileData.facebook || "",
            flooring_categories: profileData.flooring_categories || [],
            services_offered: profileData.services_offered || [],
            brands_carried: profileData.brands_carried || []
          });
          setLicenseDocUrl(profileData.license_doc_url || "");
          setInsuranceDocUrl(profileData.insurance_doc_url || "");
          setVerificationStatus(profileData.verification_status || "unverified");
          setCustomServices(profileData.custom_services || []);
          setCustomBrands(profileData.custom_brands || []);

          // Code of Conduct evaluation
          const needsReagree = profileData.needs_coc_reagree !== undefined ? !!profileData.needs_coc_reagree : (!profileData.coc_agreed || profileData.coc_agreed_version !== profileData.system_coc_version);
          setCocData({
            agreed: profileData.coc_agreed,
            version: profileData.coc_agreed_version,
            date: profileData.coc_agreed_date,
            system_version: profileData.system_coc_version,
            system_content: profileData.system_coc_content,
            needs_reagree: needsReagree
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        message.error("Unable to load profile details");
        setLoading(false);
      });
  };

  const handleAgreeCoc = () => {
    setCocAgreeLoading(true);
    dispatch(TrustedDealerService.agreeCodeOfConduct())
      .then((res) => {
        message.success("Thank you for agreeing to the Trusted Dealer Code of Conduct!");
        setCocModalVisible(false);
        setCocAgreeLoading(false);
        fetchProfileData();
      })
      .catch((err) => {
        message.error("Unable to record agreement. Please try again.");
        setCocAgreeLoading(false);
      });
  };

  const fetchInquiries = (targetId = 0) => {
    setInquiryLoading(true);
    const pId = targetId || currentProfileId || profileId || 0;
    dispatch(TrustedDealerService.getDealerInquiries(pId))
      .then((res) => {
        const list = Array.isArray(res) ? res : [];
        setInquiries(list);
        const unread = list.filter(i => i.status === 'new').length;
        setUnreadCount(unread);
        setInquiryLoading(false);
      })
      .catch((err) => {
        setInquiries([]);
        setInquiryLoading(false);
      });
  };

  const handleOpenInquiryDetails = (record) => {
    setSelectedInquiry(record);
    setInquiryModalVisible(true);
    if (record.status === 'new') {
      dispatch(TrustedDealerService.updateInquiryStatus(record.id, 'read'))
        .then(() => {
          setInquiries(prev => prev.map(item => item.id === record.id ? { ...item, status: 'read' } : item));
          setUnreadCount(prev => Math.max(0, prev - 1));
        });
    }
  };

  const handleUpdateProfile = (values) => {
    setSaveLoading(true);
    values.profile_id = currentProfileId || profileId || 0;
    values.about_me = aboutMe;
    values.profile_pic_id = profilePicId;
    values.logo_id = logoId;
    values.cover_id = coverId;
    values.gallery_ids = galleryIds;
    values.gallery = gallery;
    values.license_doc_url = licenseDocUrl;
    values.insurance_doc_url = insuranceDocUrl;
    values.custom_services = customServices;
    values.custom_brands = customBrands;

    dispatch(TrustedDealerService.updateTrustedDealerProfile(values))
      .then((res) => {
        message.success("Profile updated successfully!");
        const updatedId = res?.profile_id || values.profile_id;
        fetchProfileData(updatedId);
        setSaveLoading(false);
        setIsOrderChanged(false);
      })
      .catch((err) => {
        message.error("Unable to update profile");
        setSaveLoading(false);
      });
  };

  const [uploadingImages, setUploadingImages] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [previewGroupVisible, setPreviewGroupVisible] = useState(false);
  const [previewGroupIndex, setPreviewGroupIndex] = useState(0);
  const [activeCategoryFilter, setActiveCategoryFilter] = useState("all");
  const pendingUploadCountRef = useRef(0);
  const [isOrderChanged, setIsOrderChanged] = useState(false);

  // @dnd-kit sensors for inline drag reorder
  const dndSensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const currentList = [...gallery];
    const oldIndex = currentList.findIndex((g, i) => String(g.id || g.url || `gallery-item-${i}`) === String(active.id));
    const newIndex = currentList.findIndex((g, i) => String(g.id || g.url || `gallery-item-${i}`) === String(over.id));

    if (oldIndex !== -1 && newIndex !== -1) {
      const newGallery = arrayMove(currentList, oldIndex, newIndex);
      setGallery(newGallery);
      setGalleryIds(newGallery.map(g => g.id || g.url));
      setIsOrderChanged(true);
    }
  };

  // Licenses & Insurance Verification states
  const [licenseDocUrl, setLicenseDocUrl] = useState("");
  const [loadingLicenseDoc, setLoadingLicenseDoc] = useState(false);
  const [insuranceDocUrl, setInsuranceDocUrl] = useState("");
  const [loadingInsuranceDoc, setLoadingInsuranceDoc] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState("unverified");

  const beforeDocUpload = (file) => {
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error("Document file size must be smaller than 10MB!");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const uploadLicenseDoc = async (options) => {
    const { onSuccess, onError, file } = options;
    setLoadingLicenseDoc(true);
    const fmData = new FormData();
    fmData.append('file', file);
    try {
      const res = await axios.post(MEDIA_UPLOAD_URL, fmData, {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`
        }
      });
      const fileUrl = res.data?.url || res.data?.source_url || res.data?.src || (res.data?.link && res.data.link.match(/\.(pdf|jpg|jpeg|png|webp|gif|doc|docx)$/i) ? res.data.link : '');
      const finalDocUrl = (fileUrl && fileUrl.match(/\.(pdf|jpg|jpeg|png|webp|gif|doc|docx)$/i)) ? fileUrl : (res.data?.url || res.data?.source_url || res.data?.src || res.data?.link || '');
      if (finalDocUrl) {
        setLicenseDocUrl(finalDocUrl);
        setVerificationStatus("pending");
        onSuccess(res.data);
        message.success("License document uploaded successfully! Status updated to Pending Verification.");
      } else {
        onSuccess(res.data);
        message.success("License document uploaded successfully!");
      }
    } catch(err) {
      onError(err);
      message.error("Failed to upload license document.");
    } finally {
      setLoadingLicenseDoc(false);
    }
  };

  const uploadInsuranceDoc = async (options) => {
    const { onSuccess, onError, file } = options;
    setLoadingInsuranceDoc(true);
    const fmData = new FormData();
    fmData.append('file', file);
    try {
      const res = await axios.post(MEDIA_UPLOAD_URL, fmData, {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`
        }
      });
      const fileUrl = res.data?.url || res.data?.source_url || res.data?.src || (res.data?.link && res.data.link.match(/\.(pdf|jpg|jpeg|png|webp|gif|doc|docx)$/i) ? res.data.link : '');
      const finalDocUrl = (fileUrl && fileUrl.match(/\.(pdf|jpg|jpeg|png|webp|gif|doc|docx)$/i)) ? fileUrl : (res.data?.url || res.data?.source_url || res.data?.src || res.data?.link || '');
      if (finalDocUrl) {
        setInsuranceDocUrl(finalDocUrl);
        setVerificationStatus("pending");
        onSuccess(res.data);
        message.success("Proof of Insurance uploaded successfully! Status updated to Pending Verification.");
      } else {
        onSuccess(res.data);
        message.success("Proof of Insurance uploaded successfully!");
      }
    } catch(err) {
      onError(err);
      message.error("Failed to upload insurance document.");
    } finally {
      setLoadingInsuranceDoc(false);
    }
  };

  // Video Embed Modal states
  const [videoModalVisible, setVideoModalVisible] = useState(false);
  const [videoUrlInput, setVideoUrlInput] = useState("");
  const [videoCategoryInput, setVideoCategoryInput] = useState("");

  // Video Player Modal states (modal playback instead of new tab)
  const [videoPlayerVisible, setVideoPlayerVisible] = useState(false);
  const [activeVideoUrl, setActiveVideoUrl] = useState("");
  const [activeVideoTitle, setActiveVideoTitle] = useState("");

  const handlePlayVideoModal = (item) => {
    setActiveVideoUrl(item.url);
    setActiveVideoTitle(item.category ? `Video Preview: ${item.category}` : "Project Video Preview");
    setVideoPlayerVisible(true);
  };

  const getItemMediaDetails = (item) => {
    const url = item.url || '';
    const isVideo = (item.type === 'video') || (/\.(mp4|webm|mov|m4v)(\?.*)?$/i.test(url)) || (/(youtube\.com|youtu\.be|vimeo\.com)/i.test(url));
    
    let posterUrl = null;
    const ytMatch = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i);
    if (ytMatch && ytMatch[1]) {
      posterUrl = `https://img.youtube.com/vi/${ytMatch[1]}/hqdefault.jpg`;
    } else {
      const vimeoMatch = url.match(/vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)/i);
      if (vimeoMatch && vimeoMatch[3]) {
        posterUrl = `https://vumbnail.com/${vimeoMatch[3]}.jpg`;
      }
    }
    
    return { isVideo, posterUrl };
  };

  const handleAddVideoEmbed = () => {
    if (!videoUrlInput || !videoUrlInput.trim()) {
      message.error("Please enter a valid YouTube or Vimeo URL");
      return;
    }
    if (!isPremium && gallery.length >= 3) {
      message.warning("Free plan is limited to maximum 3 gallery items. Please upgrade to Premium!");
      return;
    }
    const cleanUrl = videoUrlInput.trim();
    const newVideoItem = {
      id: `video-${Date.now()}`,
      url: cleanUrl,
      type: 'video',
      category: videoCategoryInput ? videoCategoryInput.trim() : ''
    };
    setGallery(prev => [...prev, newVideoItem]);
    setVideoModalVisible(false);
    setVideoUrlInput("");
    setVideoCategoryInput("");
    message.success("Video link added to Project Gallery!");
  };

  const beforeUploadImage = (file) => {
    if (!isPremium) {
      const currentTotal = gallery.length + pendingUploadCountRef.current;
      if (currentTotal >= 3) {
        message.error(`Basic (Free Plan) limit is 3 items. Skipping extra file "${file.name}". Please upgrade to Premium!`);
        return Upload.LIST_IGNORE;
      }
      pendingUploadCountRef.current += 1;
    }
    const isVideo = file.type.startsWith('video/');
    const isImage = file.type.startsWith('image/');
    if (!isImage && !isVideo) {
      if (!isPremium) pendingUploadCountRef.current = Math.max(0, pendingUploadCountRef.current - 1);
      message.error("Only Image (JPG/PNG/WebP) or Video (MP4/WebM) files are supported!");
      return Upload.LIST_IGNORE;
    }
    const isLt50M = file.size / 1024 / 1024 < 50;
    if (!isLt50M) {
      if (!isPremium) pendingUploadCountRef.current = Math.max(0, pendingUploadCountRef.current - 1);
      message.error("File size must be smaller than 50MB!");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleGalleryUpload = async (options) => {
    const { onSuccess, onError, file } = options;
    if (!isPremium && gallery.length >= 3) {
      if (!isPremium) pendingUploadCountRef.current = Math.max(0, pendingUploadCountRef.current - 1);
      message.warning("Free plan is limited to maximum 3 gallery photos. Please upgrade!");
      onError("Plan limit reached");
      return;
    }

    const tempId = `temp-${Date.now()}-${Math.random()}`;
    const tempUrl = URL.createObjectURL(file);
    
    setUploadingImages(prev => [...prev, { tempId, url: tempUrl }]);

    const fmData = new FormData();
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      },
    };
    fmData.append('file', file);

    try {
      const res = await axios.post(MEDIA_UPLOAD_URL, fmData, config);
      const resp = res.data;
      const uploadedId = typeof resp === 'object' && resp !== null ? resp.id : (typeof resp === 'number' ? resp : (resp ? parseInt(resp) : 0));
      const uploadedUrl = (typeof resp === 'object' && resp !== null && (resp.source_url || resp.url)) ? (resp.source_url || resp.url) : tempUrl;

      const isVid = file.type.startsWith('video/');
      if (!isPremium) pendingUploadCountRef.current = Math.max(0, pendingUploadCountRef.current - 1);
      setGallery(prev => [...prev, { id: uploadedId, url: uploadedUrl, type: isVid ? 'video' : 'image' }]);
      setGalleryIds(prev => [...prev, uploadedId]);
      setUploadingImages(prev => prev.filter(img => img.tempId !== tempId));
      onSuccess(resp);
      message.success("Photo uploaded successfully!");
    } catch (err) {
      if (!isPremium) pendingUploadCountRef.current = Math.max(0, pendingUploadCountRef.current - 1);
      setUploadingImages(prev => prev.filter(img => img.tempId !== tempId));
      onError(err);
      message.error("Failed to upload image. Please try again.");
    }
  };

  const handleRemovePhoto = (id) => {
    const item = gallery.find(g => g.id === id);
    const { isVideo } = item ? getItemMediaDetails(item) : { isVideo: false };
    const label = isVideo ? 'Video' : 'Photo';

    Swal.fire({
      title: `Delete ${label}?`,
      text: `Are you sure you want to remove this ${label.toLowerCase()} from your project gallery?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: `Yes, delete ${label.toLowerCase()}!`
    }).then((result) => {
      if (result.isConfirmed) {
        setGallery(prev => prev.filter(gItem => gItem.id !== id));
        setGalleryIds(prev => prev.filter(gid => gid !== id));
        Swal.fire('Deleted!', `${label} has been removed from gallery.`, 'success');
      }
    });
  };

  const handleImagePreview = (targetItem) => {
    const targetUrl = typeof targetItem === 'string' ? targetItem : (targetItem?.url || targetItem);
    const photoOnlyList = gallery.filter(item => !getItemMediaDetails(item).isVideo);
    const targetIdx = photoOnlyList.findIndex(item => item.url === targetUrl);
    
    setPreviewGroupIndex(targetIdx !== -1 ? targetIdx : 0);
    setPreviewGroupVisible(true);
  };

  // Custom Services & Custom Brands Handlers (Max 5 for Premium Users)
  const handleAddCustomService = () => {
    if (!isPremium) {
      Swal.fire({
        title: '👑 Premium Feature',
        text: 'Adding custom services is exclusive to Premium Dealers. Please upgrade to unlock!',
        icon: 'warning',
        confirmButtonText: 'Upgrade Now'
      });
      return;
    }
    if (customServices.length >= 5) {
      message.warning("You can add maximum 5 custom services!");
      return;
    }
    if (!newServiceInput.trim()) {
      message.error("Please enter a custom service name");
      return;
    }
    setCustomServices([...customServices, newServiceInput.trim()]);
    setNewServiceInput("");
    message.success("Custom service added!");
  };

  const handleRemoveCustomService = (index) => {
    setCustomServices(customServices.filter((_, i) => i !== index));
  };

  const handleAddCustomBrand = () => {
    if (!isPremium) {
      Swal.fire({
        title: '👑 Premium Feature',
        text: 'Adding custom brands is exclusive to Premium Dealers. Please upgrade to unlock!',
        icon: 'warning',
        confirmButtonText: 'Upgrade Now'
      });
      return;
    }
    if (customBrands.length >= 5) {
      message.warning("You can add maximum 5 custom brands!");
      return;
    }
    if (!newBrandInput.trim()) {
      message.error("Please enter a custom brand name");
      return;
    }
    setCustomBrands([...customBrands, newBrandInput.trim()]);
    setNewBrandInput("");
    message.success("Custom brand added!");
  };

  const handleRemoveCustomBrand = (index) => {
    setCustomBrands(customBrands.filter((_, i) => i !== index));
  };

  // Profile Image Avatar Upload (matches InspectorProfile logic)
  const handleUploadProfilePic = async (options) => {
    const { onSuccess, onError, file } = options;
    setLoadingProfilePic(true);
    const fmData = new FormData();
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      },
    };
    fmData.append('file', file);
    try {
      const res = await axios.post(MEDIA_UPLOAD_URL, fmData, config);
      const resp = res.data;
      const uploadedId = typeof resp === 'object' && resp !== null ? resp.id : (typeof resp === 'number' ? resp : parseInt(resp, 10));
      const uploadedUrl = (typeof resp === 'object' && resp !== null && (resp.source_url || resp.url)) ? (resp.source_url || resp.url) : URL.createObjectURL(file);
      setProfilePicUrl(uploadedUrl);
      setProfilePicId(uploadedId);
      onSuccess(resp);
      message.success("Profile photo uploaded successfully!");
    } catch (err) {
      onError(err);
      message.error("Failed to upload profile photo.");
    } finally {
      setLoadingProfilePic(false);
    }
  };

  const DealerProfileUploadButton = (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      <PlusOutlined style={{ fontSize: 20, color: "#334155", marginBottom: 6 }} />
      <span style={{ fontSize: 13, fontWeight: 500, color: "#334155" }}>
        Upload Profile
      </span>
    </div>
  );

  // Image Upload helpers
  const uploadImage = async (options) => {
    const { onSuccess, onError, onProgress, file } = options;
    const fmData = new FormData();
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      },
      onUploadProgress: (event) => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        onProgress({ percent });
      },
    };
    fmData.append('file', file);
    try {
      const res = await axios.post(MEDIA_UPLOAD_URL, fmData, config);
      onSuccess(res.data);
    } catch (err) {
      onError({ err });
    }
  };

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const beforeUpload = (file) => {
    const isVideo = file.type.startsWith('video/');
    if (isVideo) {
      message.error("Videos are not supported here! Please upload photos only.");
      return Upload.LIST_IGNORE;
    }
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return Upload.LIST_IGNORE;
    }
    const isLt20M = file.size / 1024 / 1024 < 20;
    if (!isLt20M) {
      message.error("Image must be smaller than 20MB!");
      return Upload.LIST_IGNORE;
    }
    return isJpgOrPng && isLt20M;
  };

  const handleLogoChange = (info) => {
    if (info.file.status === "uploading") {
      setLoadingLogo(true);
      return;
    }
    if (info.file.status === "done") {
      const resp = info.file.response;
      const uploadedId = typeof resp === 'object' && resp !== null ? resp.id : (typeof resp === 'number' ? resp : (resp ? parseInt(resp) : 0));
      getBase64(info.file.originFileObj, (url) => {
        setLoadingLogo(false);
        setLogoUrl(url);
        setLogoId(uploadedId);
      });
    }
  };

  const handleCoverChange = (info) => {
    if (info.file.status === "uploading") {
      setLoadingCover(true);
      return;
    }
    if (info.file.status === "done") {
      const resp = info.file.response;
      const uploadedId = typeof resp === 'object' && resp !== null ? resp.id : (typeof resp === 'number' ? resp : (resp ? parseInt(resp) : 0));
      getBase64(info.file.originFileObj, (url) => {
        setLoadingCover(false);
        setCoverUrl(url);
        setCoverId(uploadedId);
      });
    }
  };

  const uploadButton = (loadingState, text) => (
    <div>
      {loadingState ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>{text}</div>
    </div>
  );

  const progress = {
    strokeColor: {
      '0%': '#108ee9',
      '100%': '#87d068',
    },
    strokeWidth: 3,
    format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
  };

  const inquiryColumns = [
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 90,
      render: (status) => (
        <Tag color={status === 'new' ? 'red' : 'green'}>
          {status === 'new' ? 'New Lead' : 'Read'}
        </Tag>
      )
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      render: (text) => <strong>{text}</strong>
    },
    {
      title: 'Email',
      dataIndex: 'customer_email',
      key: 'customer_email',
      render: (email) => <a href={`mailto:${email}`}>{email}</a>
    },
    {
      title: 'Phone',
      dataIndex: 'customer_phone',
      key: 'customer_phone',
      render: (phone) => phone ? <a href={`tel:${phone}`}>{phone}</a> : '-'
    },
    {
      title: 'Inquiry Type',
      dataIndex: 'inquiry_type',
      key: 'inquiry_type',
      render: (type) => <Tag color="blue">{type || 'General'}</Tag>
    },
    {
      title: 'Date Received',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => date ? new Date(date).toLocaleDateString() : '-'
    },
    {
      title: 'Action',
      key: 'action',
      width: 130,
      render: (_, record) => (
        <Button 
          type="primary" 
          size="small" 
          icon={<EyeOutlined />}
          onClick={() => handleOpenInquiryDetails(record)}
        >
          View Lead
        </Button>
      )
    }
  ];

  return (
    <div className="inspectionWrapper trusted-dealer-dashboard-wrapper">
      <TrustedDealerCocGuard 
        profileId={currentProfileId || profileId} 
        initialCocData={cocData}
        onAgreedSuccess={() => fetchProfileData(currentProfileId || profileId)}
        isPreviewMode={previewCocModalVisible}
        onClosePreview={() => setPreviewCocModalVisible(false)}
      />
      <div className="inspectionHeader">
        <PagesHeader title="Trusted Dealer Dashboard" />
      </div>
      <div className="buttonSection" style={{ position: 'relative', zIndex: 100 }}>
        <div className="container-xxl">
          <ButtonBar />
        </div>
      </div>
      <div className="container-xxl inspector-profile-container" style={{ padding: "20px 0" }}>
        <Row justify="center">
        <Col xs={24} md={20}>
          {loading ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
              {/* Top Tab Bar & Premium Badge Skeleton */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '8px' }}>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <Skeleton.Button active style={{ width: 150, maxWidth: '100%', height: 38, borderRadius: 20 }} />
                  <Skeleton.Button active style={{ width: 140, maxWidth: '100%', height: 38, borderRadius: 20 }} />
                </div>
                <Skeleton.Button active style={{ width: 130, maxWidth: '100%', height: 28, borderRadius: 14 }} />
              </div>

              {/* CARD 1: 1. Basic Company Information */}
              <Card style={{ borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 16px rgba(0,0,0,0.02)' }}>
                {/* Title */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '24px' }}>
                  <Skeleton.Avatar active size="small" shape="circle" style={{ width: 16, height: 16 }} />
                  <Skeleton.Input active size="small" style={{ width: 220, height: 16, borderRadius: 4 }} />
                </div>
                
                {/* Row 1: Company Name & Address */}
                <Row gutter={20}>
                  <Col xs={24} md={12}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', marginBottom: 16 }}>
                      <Skeleton.Input active size="small" style={{ width: 180, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                  <Col xs={24} md={12}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', marginBottom: 16 }}>
                      <Skeleton.Input active size="small" style={{ width: 90, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                </Row>

                {/* Row 2: Email, Phone, Website */}
                <Row gutter={20}>
                  <Col xs={24} md={8}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', marginBottom: 16 }}>
                      <Skeleton.Input active size="small" style={{ width: 110, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                  <Col xs={24} md={8}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', marginBottom: 16 }}>
                      <Skeleton.Input active size="small" style={{ width: 110, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                  <Col xs={24} md={8}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', marginBottom: 16 }}>
                      <Skeleton.Input active size="small" style={{ width: 90, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                </Row>

                {/* Row 3: Years in Business & Service Radius */}
                <Row gutter={20}>
                  <Col xs={24} md={12}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 130, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                  <Col xs={24} md={12}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 150, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                </Row>
              </Card>

              {/* CARD 2: 2. About Company & Brand Images */}
              <Card style={{ borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 16px rgba(0,0,0,0.02)' }}>
                {/* Title */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '24px' }}>
                  <Skeleton.Avatar active size="small" shape="circle" style={{ width: 16, height: 16 }} />
                  <Skeleton.Input active size="small" style={{ width: 260, height: 16, borderRadius: 4 }} />
                </div>

                {/* Description Rich Editor Box Skeleton */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', marginBottom: 24 }}>
                  <Skeleton.Input active size="small" style={{ width: 180, height: 12, borderRadius: 4 }} />
                  <div style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 16, background: '#fafafa' }}>
                    <div style={{ display: 'flex', gap: 8, marginBottom: 16, borderBottom: '1px solid #e2e8f0', paddingBottom: 10 }}>
                      {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
                        <Skeleton.Button active key={i} size="small" style={{ width: 28, height: 28, borderRadius: 4 }} />
                      ))}
                    </div>
                    <Skeleton active paragraph={{ rows: 3 }} title={false} />
                  </div>
                </div>

                {/* Company Logo & Profile Cover Image Banner */}
                <Row gutter={24} style={{ marginBottom: 24 }}>
                  <Col xs={24} md={8}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 110, height: 12, borderRadius: 4 }} />
                      <Skeleton.Avatar active shape="square" style={{ width: 104, height: 104, borderRadius: 10 }} />
                    </div>
                  </Col>
                  <Col xs={24} md={16}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 160, height: 12, borderRadius: 4 }} />
                      <Skeleton.Avatar active shape="square" style={{ width: 180, height: 104, borderRadius: 10 }} />
                    </div>
                  </Col>
                </Row>

                {/* Social Media Profiles */}
                <Divider style={{ margin: '15px 0 20px' }} />
                <Row gutter={20}>
                  <Col xs={24} md={8}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 100, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                  <Col xs={24} md={8}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 100, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                  <Col xs={24} md={8}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 100, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                </Row>
              </Card>

              {/* CARD 3: 3. Specializations, Services & Brands */}
              <Card style={{ borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 16px rgba(0,0,0,0.02)' }}>
                {/* Title */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '24px' }}>
                  <Skeleton.Avatar active size="small" shape="circle" style={{ width: 16, height: 16 }} />
                  <Skeleton.Input active size="small" style={{ width: 280, height: 16, borderRadius: 4 }} />
                </div>

                <Row gutter={[24, 20]}>
                  {/* Dealer Specializations */}
                  <Col xs={24} md={9}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 150, height: 12, marginBottom: 4, borderRadius: 4 }} />
                      <Row gutter={[8, 10]}>
                        {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
                          <Col span={12} key={i}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                              <Skeleton.Avatar active size="small" shape="circle" style={{ width: 16, height: 16 }} />
                              <Skeleton.Input active size="small" style={{ width: 80, height: 12, borderRadius: 3 }} />
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </Col>

                  {/* Services Offered */}
                  <Col xs={24} md={7}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 120, height: 12, marginBottom: 4, borderRadius: 4 }} />
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        {[1, 2, 3, 4, 5].map(i => (
                          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <Skeleton.Avatar active size="small" shape="circle" style={{ width: 16, height: 16 }} />
                            <Skeleton.Input active size="small" style={{ width: 90, height: 12, borderRadius: 3 }} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </Col>

                  {/* Flooring Brands Carried */}
                  <Col xs={24} md={8}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 160, height: 12, marginBottom: 4, borderRadius: 4 }} />
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        {[1, 2, 3, 4, 5].map(i => (
                          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <Skeleton.Avatar active size="small" shape="circle" style={{ width: 16, height: 16 }} />
                            <Skeleton.Input active size="small" style={{ width: 100, height: 12, borderRadius: 3 }} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>

              {/* CARD 4: 4. Business Verification & Insurance Proof */}
              <Card style={{ borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 16px rgba(0,0,0,0.02)' }}>
                {/* Title & Badge */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Skeleton.Avatar active size="small" shape="circle" style={{ width: 16, height: 16 }} />
                    <Skeleton.Input active size="small" style={{ width: 300, height: 16, borderRadius: 4 }} />
                  </div>
                  <Skeleton.Button active style={{ width: 110, height: 26, borderRadius: 20 }} />
                </div>

                <Row gutter={20} style={{ marginBottom: 16 }}>
                  <Col xs={24} md={12}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 200, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                  <Col xs={24} md={12}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 220, height: 12, borderRadius: 4 }} />
                      <Skeleton.Input active size="large" style={{ width: '100%', height: 40, borderRadius: 6 }} />
                    </div>
                  </Col>
                </Row>

                <Row gutter={20}>
                  <Col xs={24} md={12}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 160, height: 12, borderRadius: 4 }} />
                      <Skeleton.Button active style={{ width: '100%', height: 40, borderRadius: 8 }} />
                    </div>
                  </Col>
                  <Col xs={24} md={12}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                      <Skeleton.Input active size="small" style={{ width: 190, height: 12, borderRadius: 4 }} />
                      <Skeleton.Button active style={{ width: '100%', height: 40, borderRadius: 8 }} />
                    </div>
                  </Col>
                </Row>
              </Card>

              {/* Save Settings Button */}
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                <Skeleton.Button active style={{ width: 190, height: 45, borderRadius: 8 }} />
              </div>
            </div>
          ) : (
            <Form
              form={form}
              name="editProfileForm"
              id="editProfileForm"
              layout="vertical"
              onFinish={handleUpdateProfile}
              style={{marginTop: 16}}
            >
            <div className="trusted-dealer-dashboard-form">
              <Tabs 
                defaultActiveKey="1"
                className="custom-dealer-tabs"
                moreIcon={null}
                tabBarExtraContent={
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                    <Tag color={isPremium ? "gold" : "blue"} style={{ padding: "5px 14px", borderRadius: "14px", fontWeight: "700", fontSize: "12px" }}>
                      {isPremium ? "★ Premium Partner" : "Basic (Free Plan)"}
                    </Tag>
                    <Button
                      type="default"
                      size="small"
                      icon={
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                          <span style={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            background: cocData?.needs_reagree ? '#ef4444' : '#22c55e',
                            boxShadow: cocData?.needs_reagree ? '0 0 8px #ef4444' : 'none',
                            display: 'inline-block'
                          }} />
                          <SafetyCertificateOutlined style={{ color: cocData?.needs_reagree ? '#ef4444' : '#0284c7' }} />
                        </span>
                      }
                      onClick={() => setPreviewCocModalVisible(true)}
                      style={{ 
                        borderRadius: 14, 
                        fontSize: 12, 
                        fontWeight: 600, 
                        borderColor: cocData?.needs_reagree ? '#fca5a5' : '#cbd5e1',
                        background: cocData?.needs_reagree ? '#fff5f5' : '#ffffff',
                        color: cocData?.needs_reagree ? '#991b1b' : '#334155'
                      }}
                    >
                      Code of Conduct (v{cocData?.system_version || '1.0'})
                    </Button>
                  </div>
                }
              >
            
            {/* TAB 1: PROFILE DETAILS */}
            <TabPane tab={<span><UserOutlined /> Profile Information</span>} key="1">
              
              {/* SECTION 1: BASIC COMPANY INFORMATION */}
              <div style={{ background: '#ffffff', padding: '24px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '24px', boxShadow: '0 2px 6px rgba(0,0,0,0.02)' }}>
                {/* EXACT INSPECTOR PROFILE CIRCULAR AVATAR-WRAPPER */}
                <Row gutter={16}>
                  <Col xs={24} md={24} xl={24}>
                    <div className="avatar-wrapper" style={{ margin: "10px 0 24px 0" }}>
                      <Spin spinning={loadingProfilePic}>
                        <Upload
                          className="profile-image-upload"
                          customRequest={handleUploadProfilePic}
                          showUploadList={false}
                          beforeUpload={beforeUpload}
                        >
                          {profilePicUrl ? (
                            <img
                              src={profilePicUrl}
                              alt="avatar"
                              className="profileImage-Box"
                              style={{ width: "100%" }}
                            />
                          ) : (
                            DealerProfileUploadButton
                          )}

                          <Tooltip title="Upload Profile Picture">
                            <div className="upload-button">
                              <CloudUploadOutlined />
                            </div>
                          </Tooltip>
                        </Upload>
                      </Spin>
                    </div>
                  </Col>
                </Row>

                <h5 style={{ fontWeight: 700, color: '#0f172a', marginBottom: 18, fontSize: 16, borderBottom: '2px solid #f1f5f9', paddingBottom: 10 }}>
                  🏢 1. Basic Company Information
                </h5>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item label="Company / Organization Name" name="organization_name" rules={[{ required: true, message: 'Please enter company name' }]}>
                      <Input prefix={<UserOutlined style={{ color: '#94a3b8' }} />} placeholder="Company Name" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Address" name="address" rules={[{ required: true, message: 'Please enter business address' }]}>
                      <Input prefix={<EnvironmentOutlined style={{ color: '#94a3b8' }} />} placeholder="Business Address" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col xs={24} md={8}>
                    <Form.Item label="Contact Email" name="email" rules={[{ required: true, message: 'Please enter email' }]}>
                      <Input prefix={<MailOutlined style={{ color: '#94a3b8' }} />} placeholder="Email" type="email" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item label="Phone Number" name="phone_number">
                      <Input prefix={<PhoneOutlined style={{ color: '#94a3b8' }} />} placeholder="Phone" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item label="Website Link" name="website">
                      <Input prefix={<LinkOutlined style={{ color: '#94a3b8' }} />} placeholder="Website URL" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item label="Years in Business" name="years_in_business">
                      <Input placeholder="e.g. 5 Years" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Service Radius (Miles)" name="service_radius" tooltip="Maximum radius distance from your showroom where you provide installation and estimates">
                      <Select placeholder="Select Service Radius">
                        <Select.Option value="25">25 Miles</Select.Option>
                        <Select.Option value="50">50 Miles</Select.Option>
                        <Select.Option value="100">100 Miles</Select.Option>
                        <Select.Option value="150">150 Miles</Select.Option>
                        <Select.Option value="200">200 Miles</Select.Option>
                        <Select.Option value="300">300 Miles</Select.Option>
                        <Select.Option value="500">500 Miles (Nationwide)</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              {/* SECTION 2: ABOUT & BRANDING */}
              <div style={{ background: '#ffffff', padding: '24px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '24px', boxShadow: '0 2px 6px rgba(0,0,0,0.02)' }}>
                <h5 style={{ fontWeight: 700, color: '#0f172a', marginBottom: 18, fontSize: 16, borderBottom: '2px solid #f1f5f9', paddingBottom: 10 }}>
                  📝 2. About Company & Brand Images
                </h5>
                <Row gutter={16}>
                  <Col xs={24}>
                    <Form.Item label="About the Company (Description)">
                      <SunEditor
                        setContents={aboutMe}
                        onChange={(content) => setAboutMe(content)}
                        setOptions={SunEditorOpts}
                        placeholder="Provide a detailed overview of your company, history, showroom, and client commitment..."
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16} style={{ marginTop: 10 }}>
                  <Col xs={24} md={12}>
                    <Form.Item label="Company Logo">
                      <Upload
                        name="file"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        customRequest={uploadImage}
                        beforeUpload={beforeUpload}
                        onChange={handleLogoChange}
                      >
                        {logoUrl ? <img src={logoUrl} alt="Logo" style={{ width: '100%', borderRadius: 4 }} /> : uploadButton(loadingLogo, 'Logo')}
                      </Upload>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Profile Cover Image Banner">
                      <Upload
                        name="file"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        customRequest={uploadImage}
                        beforeUpload={beforeUpload}
                        onChange={handleCoverChange}
                      >
                        {coverUrl ? <img src={coverUrl} alt="Cover" style={{ width: '100%', borderRadius: 4 }} /> : uploadButton(loadingCover, 'Cover')}
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>

                <Divider orientation="left" style={{ borderColor: '#e2e8f0', color: '#475569', fontSize: 13, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', margin: '20px 0 16px' }}>Social Media Profiles</Divider>
                <Row gutter={16}>
                  <Col xs={24} md={8}>
                    <Form.Item name="facebook" label="Facebook URL">
                      <Input prefix={<FacebookFilled style={{ color: '#1877f2' }} />} placeholder="Facebook page link" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item name="instagram" label="Instagram URL">
                      <Input prefix={<InstagramOutlined style={{ color: '#e4405f' }} />} placeholder="Instagram username" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item name="linkedin" label="LinkedIn URL">
                      <Input prefix={<LinkedinFilled style={{ color: '#0a66c2' }} />} placeholder="LinkedIn business URL" />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              {/* SECTION 3: BUSINESS OFFERINGS & BRANDS */}
              <div style={{ background: '#ffffff', padding: '24px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '24px', boxShadow: '0 2px 6px rgba(0,0,0,0.02)' }}>
                <h5 style={{ fontWeight: 700, color: '#0f172a', marginBottom: 18, fontSize: 16, borderBottom: '2px solid #f1f5f9', paddingBottom: 10 }}>
                  🛠️ 3. Specializations, Services & Brands
                </h5>
                <Row gutter={16}>
                  <Col xs={24} md={8}>
                    <Form.Item name="flooring_categories" label="Dealer Specializations">
                      <Checkbox.Group style={{ width: '100%' }}>
                        <Row gutter={[4, 8]}>
                          <Col span={12}><Checkbox value="hardwood_flooring_dealer">Hardwood Dealer</Checkbox></Col>
                          <Col span={12}><Checkbox value="luxury_vinyl_flooring_dealer">Luxury Vinyl</Checkbox></Col>
                          <Col span={12}><Checkbox value="laminate_flooring_dealer">Laminate Dealer</Checkbox></Col>
                          <Col span={12}><Checkbox value="tile_stone_dealer">Tile & Stone</Checkbox></Col>
                          <Col span={12}><Checkbox value="carpet_dealer">Carpet Dealer</Checkbox></Col>
                          <Col span={12}><Checkbox value="area_rug_dealer">Area Rugs</Checkbox></Col>
                          <Col span={12}><Checkbox value="waterproof_flooring_dealer">Waterproof Dealer</Checkbox></Col>
                          <Col span={12}><Checkbox value="residential_flooring_dealer">Residential Dealer</Checkbox></Col>
                          <Col span={12}><Checkbox value="commercial_flooring_dealer">Commercial Dealer</Checkbox></Col>
                          <Col span={12}><Checkbox value="commercial_flooring_supplier">Commercial Supplier</Checkbox></Col>
                        </Row>
                      </Checkbox.Group>
                    </Form.Item>
                  </Col>
                   <Col xs={24} md={8}>
                    <Form.Item name="services_offered" label="Services Offered">
                      <Checkbox.Group style={{ width: '100%' }}>
                        <Row gutter={[4, 8]}>
                          <Col span={12}><Checkbox value="sales">Sales</Checkbox></Col>
                          <Col span={12}><Checkbox value="installation">Installation</Checkbox></Col>
                          <Col span={12}><Checkbox value="replacement">Replacement</Checkbox></Col>
                          <Col span={12}><Checkbox value="repair">Repair</Checkbox></Col>
                          <Col span={12}><Checkbox value="refinishing">Refinishing</Checkbox></Col>
                        </Row>
                      </Checkbox.Group>
                    </Form.Item>

                    <div style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid #f1f5f9' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                        <span style={{ fontSize: 12.5, fontWeight: 700, color: '#0f172a', display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                          <span>✨</span> Additional Services 
                          {!isPremium && <span style={{ fontSize: 10, fontWeight: 700, color: '#0284c7', background: '#e0f2fe', padding: '2px 8px', borderRadius: 10 }}>PRO</span>}
                        </span>
                        <span style={{ fontSize: 11, color: '#64748b', fontWeight: 600 }}>{customServices.length} / 5</span>
                      </div>
                      
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        background: isPremium ? '#ffffff' : '#f8fafc', 
                        border: '1.5px solid #cbd5e1', 
                        borderRadius: '24px', 
                        padding: '3px 4px 3px 14px',
                        transition: 'all 0.2s ease-in-out',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.02)'
                      }}>
                        <input 
                          type="text"
                          placeholder={isPremium ? "Add service (e.g. Epoxy Coating)..." : "Upgrade to PRO to add custom services"}
                          value={newServiceInput}
                          onChange={(e) => setNewServiceInput(e.target.value)}
                          disabled={!isPremium || customServices.length >= 5}
                          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddCustomService(); } }}
                          style={{ 
                            border: 'none', 
                            outline: 'none', 
                            background: 'transparent', 
                            flex: 1, 
                            fontSize: '12px', 
                            color: '#0f172a',
                            fontWeight: 500
                          }}
                        />
                        <button 
                          type="button"
                          onClick={handleAddCustomService}
                          disabled={!isPremium || customServices.length >= 5}
                          style={{ 
                            borderRadius: '20px', 
                            fontWeight: 700, 
                            background: isPremium ? 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)' : '#94a3b8', 
                            border: 'none', 
                            color: '#ffffff', 
                            fontSize: '11.5px',
                            padding: '5px 14px',
                            cursor: isPremium && customServices.length < 5 ? 'pointer' : 'not-allowed',
                            boxShadow: isPremium ? '0 2px 6px rgba(2,132,199,0.25)' : 'none',
                            transition: 'all 0.2s ease'
                          }}
                        >
                          + Add
                        </button>
                      </div>

                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 10 }}>
                        {customServices.map((svc, idx) => (
                          <Tag 
                            key={idx} 
                            closable 
                            onClose={() => handleRemoveCustomService(idx)}
                            style={{ 
                              padding: '3px 10px', 
                              borderRadius: '16px', 
                              fontSize: '11.5px', 
                              fontWeight: 600, 
                              background: '#f0f9ff', 
                              color: '#0369a1', 
                              border: '1px solid #bae6fd',
                              boxShadow: '0 2px 4px rgba(2,132,199,0.06)',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 4
                            }}
                          >
                            ✓ {svc}
                          </Tag>
                        ))}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} md={8}>
                    <Form.Item name="brands_carried" label="Flooring Brands Carried">
                      <Checkbox.Group style={{ width: '100%' }}>
                        <Row gutter={[4, 8]}>
                          <Col span={12}><Checkbox value="mohawk">Mohawk</Checkbox></Col>
                          <Col span={12}><Checkbox value="shaw">Shaw</Checkbox></Col>
                          <Col span={12}><Checkbox value="engineered">Engineered</Checkbox></Col>
                          <Col span={12}><Checkbox value="mannington">Mannington</Checkbox></Col>
                          <Col span={12}><Checkbox value="karastan">Karastan</Checkbox></Col>
                        </Row>
                      </Checkbox.Group>
                    </Form.Item>

                    <div style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid #f1f5f9' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                        <span style={{ fontSize: 12.5, fontWeight: 700, color: '#0f172a', display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                          <span>🏷️</span> Additional Brands 
                          {!isPremium && <span style={{ fontSize: 10, fontWeight: 700, color: '#7e22ce', background: '#faf5ff', padding: '2px 8px', borderRadius: 10 }}>PRO</span>}
                        </span>
                        <span style={{ fontSize: 11, color: '#64748b', fontWeight: 600 }}>{customBrands.length} / 5</span>
                      </div>
                      
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        background: isPremium ? '#ffffff' : '#f8fafc', 
                        border: '1.5px solid #cbd5e1', 
                        borderRadius: '24px', 
                        padding: '3px 4px 3px 14px',
                        transition: 'all 0.2s ease-in-out',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.02)'
                      }}>
                        <input 
                          type="text"
                          placeholder={isPremium ? "Add brand name..." : "Upgrade to PRO to add custom brands"}
                          value={newBrandInput}
                          onChange={(e) => setNewBrandInput(e.target.value)}
                          disabled={!isPremium || customBrands.length >= 5}
                          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddCustomBrand(); } }}
                          style={{ 
                            border: 'none', 
                            outline: 'none', 
                            background: 'transparent', 
                            flex: 1, 
                            fontSize: '12px', 
                            color: '#0f172a',
                            fontWeight: 500
                          }}
                        />
                        <button 
                          type="button"
                          onClick={handleAddCustomBrand}
                          disabled={!isPremium || customBrands.length >= 5}
                          style={{ 
                            borderRadius: '20px', 
                            fontWeight: 700, 
                            background: isPremium ? 'linear-gradient(135deg, #7e22ce 0%, #6b21a8 100%)' : '#94a3b8', 
                            border: 'none', 
                            color: '#ffffff', 
                            fontSize: '11.5px',
                            padding: '5px 14px',
                            cursor: isPremium && customBrands.length < 5 ? 'pointer' : 'not-allowed',
                            boxShadow: isPremium ? '0 2px 6px rgba(126,34,206,0.25)' : 'none',
                            transition: 'all 0.2s ease'
                          }}
                        >
                          + Add
                        </button>
                      </div>

                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 10 }}>
                        {customBrands.map((brand, idx) => (
                          <Tag 
                            key={idx} 
                            closable 
                            onClose={() => handleRemoveCustomBrand(idx)}
                            style={{ 
                              padding: '3px 10px', 
                              borderRadius: '16px', 
                              fontSize: '11.5px', 
                              fontWeight: 600, 
                              background: '#faf5ff', 
                              color: '#7e22ce', 
                              border: '1px solid #e9d5ff',
                              boxShadow: '0 2px 4px rgba(126,34,206,0.06)',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 4
                            }}
                          >
                            ✓ {brand}
                          </Tag>
                        ))}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              {/* SECTION 4: LICENSES & INSURANCE VERIFICATION */}
              <div style={{ background: '#f8fafc', padding: 24, borderRadius: 12, border: '1px solid #cbd5e1', marginBottom: 25 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
                  <div>
                    <h5 style={{ margin: 0, fontWeight: 700, color: '#0f172a', fontSize: 16 }}>🛡️ 4. Business Verification & Insurance Proof</h5>
                    <p style={{ margin: 0, fontSize: 12, color: '#64748b', marginTop: 2 }}>
                      Upload your State Contractor License & Liability Insurance proof to get Verified Trust Badges on your profile page.
                    </p>
                  </div>
                  {verificationStatus === 'verified' ? (
                    <Tag style={{ padding: '6px 16px', borderRadius: 20, fontWeight: 700, fontSize: 13, background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)', color: '#15803d', border: '1px solid #86efac', display: 'inline-flex', alignItems: 'center', gap: 6, boxShadow: '0 2px 6px rgba(21,128,61,0.12)' }}>
                      <CheckCircleFilled style={{ color: '#16a34a', fontSize: 15 }} /> Verified Dealer
                    </Tag>
                  ) : (licenseDocUrl || insuranceDocUrl) ? (
                    <Tag style={{ padding: '6px 16px', borderRadius: 20, fontWeight: 700, fontSize: 13, background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)', color: '#b45309', border: '1px solid #fcd34d', display: 'inline-flex', alignItems: 'center', gap: 6, boxShadow: '0 2px 6px rgba(180,83,9,0.12)' }}>
                      <ClockCircleOutlined style={{ color: '#d97706', fontSize: 15 }} /> Pending Verification
                    </Tag>
                  ) : (
                    <Tag style={{ padding: '6px 16px', borderRadius: 20, fontWeight: 600, fontSize: 13, background: '#f1f5f9', color: '#64748b', border: '1px solid #cbd5e1', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                      <SafetyCertificateOutlined style={{ color: '#94a3b8', fontSize: 15 }} /> Unverified
                    </Tag>
                  )}
                </div>

                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item label="Contractor / Business License Number" name="license_number" tooltip="State Contractor / Trade License Number">
                      <Input prefix={<FileTextOutlined style={{ color: '#94a3b8' }} />} placeholder="e.g. CT-892410-B" />
                    </Form.Item>
                    <Form.Item label="Upload Proof of License (PDF / Image)" tooltip="Upload copy of State License or Registration Certificate">
                      <Upload
                        name="file"
                        customRequest={uploadLicenseDoc}
                        beforeUpload={beforeDocUpload}
                        showUploadList={false}
                      >
                        <Button icon={<UploadOutlined />} loading={loadingLicenseDoc} style={{ borderRadius: 6, maxWidth: '100%', whiteSpace: 'normal', height: 'auto', padding: '8px 14px', textAlign: 'left' }}>
                          {licenseDocUrl ? "Replace License Document" : "Upload License Document (PDF/JPG)"}
                        </Button>
                      </Upload>
                      {licenseDocUrl && (
                        <div style={{ marginTop: 12, background: '#f0fdf4', border: '1px solid #bbf7d0', padding: '10px 14px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.02)' }}>
                          <div style={{ fontSize: 13, color: '#15803d', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
                            <CheckCircleFilled style={{ color: '#16a34a', fontSize: 15 }} />
                            <span>License Document Uploaded</span>
                          </div>
                          <a 
                            href={licenseDocUrl} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            style={{
                              background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)',
                              color: '#ffffff',
                              padding: '5px 14px',
                              borderRadius: '20px',
                              fontWeight: 600,
                              fontSize: 12,
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 5,
                              boxShadow: '0 2px 6px rgba(2, 132, 199, 0.25)',
                              textDecoration: 'none'
                            }}
                          >
                            <EyeOutlined /> View Document
                          </a>
                        </div>
                      )}
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12}>
                    <Form.Item label="Insurance Policy / Provider Info" name="insurance_policy" tooltip="General Liability Insurance Provider & Policy Number">
                      <Input prefix={<SafetyCertificateOutlined style={{ color: '#94a3b8' }} />} placeholder="e.g. State Farm - Policy #SF-991204" />
                    </Form.Item>
                    <Form.Item label="Upload Proof of Insurance (COI Certificate)" tooltip="Upload Certificate of Insurance (COI)">
                      <Upload
                        name="file"
                        customRequest={uploadInsuranceDoc}
                        beforeUpload={beforeDocUpload}
                        showUploadList={false}
                      >
                        <Button icon={<UploadOutlined />} loading={loadingInsuranceDoc} style={{ borderRadius: 6, maxWidth: '100%', whiteSpace: 'normal', height: 'auto', padding: '8px 14px', textAlign: 'left' }}>
                          {insuranceDocUrl ? "Replace Insurance Document" : "Upload Insurance COI Document (PDF/JPG)"}
                        </Button>
                      </Upload>
                      {insuranceDocUrl && (
                        <div style={{ marginTop: 12, background: '#f0fdf4', border: '1px solid #bbf7d0', padding: '10px 14px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.02)' }}>
                          <div style={{ fontSize: 13, color: '#15803d', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
                            <CheckCircleFilled style={{ color: '#16a34a', fontSize: 15 }} />
                            <span>Insurance COI Uploaded</span>
                          </div>
                          <a 
                            href={insuranceDocUrl} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            style={{
                              background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                              color: '#ffffff',
                              padding: '5px 14px',
                              borderRadius: '20px',
                              fontWeight: 600,
                              fontSize: 12,
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 5,
                              boxShadow: '0 2px 6px rgba(5, 150, 105, 0.25)',
                              textDecoration: 'none'
                            }}
                          >
                            <EyeOutlined /> View Document
                          </a>
                        </div>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </TabPane>

            {/* TAB 2: PORTFOLIO GALLERY */}
            <TabPane className="video-tab" tab={<span><PictureOutlined /> Project Gallery</span>} key="2">
              <div style={{ background: '#ffffff', padding: '24px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: 16 }}>
                <span className="tab-content-title" style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', margin: 0 }}>
                  Project Photos & Videos Gallery
                </span>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {isPremium && (
                    <Button 
                      type="primary" 
                      icon={<ProjectOutlined />} 
                      onClick={() => navigate('/projects')}
                      style={{ borderRadius: 6, background: 'linear-gradient(135deg, #0a497b 0%, #0284c7 100%)', borderColor: '#0a497b', fontWeight: 600, height: 'auto', padding: '6px 14px' }}
                    >
                      Photo Projects
                    </Button>
                  )}
                  <Button 
                    type="default" 
                    icon={<PlusOutlined />} 
                    onClick={() => setVideoModalVisible(true)}
                    disabled={!isPremium && (gallery.length + uploadingImages.length) >= 3}
                    style={{ borderRadius: 6, borderColor: '#0284c7', color: '#0284c7', fontWeight: 600, maxWidth: '100%', whiteSpace: 'normal', height: 'auto', padding: '6px 14px' }}
                  >
                    Add Video Link (YouTube/Vimeo)
                  </Button>
                </div>
              </div>

              
              <Upload.Dragger
                customRequest={handleGalleryUpload}
                beforeUpload={beforeUploadImage}
                showUploadList={false}
                accept="image/*,video/*"
                multiple
                disabled={!isPremium && (gallery.length + uploadingImages.length) >= 3}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined style={{ fontSize: '48px', color: (!isPremium && (gallery.length + uploadingImages.length) >= 3) ? '#cbd5e1' : '#1890ff' }} />
                </p>
                <p className="ant-upload-text" style={{ color: (!isPremium && (gallery.length + uploadingImages.length) >= 3) ? '#94a3b8' : undefined }}>
                  {(!isPremium && (gallery.length + uploadingImages.length) >= 3) ? "Upload Limit Reached (3/3 Items)" : "Click or drag image/video files to this area to upload"}
                </p>
                <p className="ant-upload-hint">Support for single or bulk upload. Image & Video files (MP4/WebM/JPG/PNG up to 50MB)</p>
              </Upload.Dragger>

              {!isPremium && (
                <div style={{ background: (gallery.length + uploadingImages.length) >= 3 ? '#fffbe6' : '#f8fafc', border: (gallery.length + uploadingImages.length) >= 3 ? '1px solid #ffe58f' : '1px solid #e2e8f0', padding: '12px 16px', borderRadius: 8, marginTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: (gallery.length + uploadingImages.length) >= 3 ? '#d97706' : '#64748b', fontWeight: 500 }}>
                    {(gallery.length + uploadingImages.length) >= 3 
                      ? "🔒 Basic (Free Plan) gallery photo limit reached (3/3 items). Upgrade to Premium to upload more photos!" 
                      : `Note: Basic (Free Plan) is limited to maximum 3 gallery items (${gallery.length}/3 uploaded).`
                    }
                  </span>
                  {(gallery.length + uploadingImages.length) >= 3 && (
                    <Button type="primary" size="small" style={{ backgroundColor: '#0a497b', borderColor: '#0a497b' }} onClick={() => window.open(`${WEBSITE_URL}/membership-account/membership-levels/`, '_blank')}>
                      Upgrade Plan
                    </Button>
                  )}
                </div>
              )}
              {/* Category Filter Tabs Bar (Luxury Design) */}
              {gallery.length > 0 && (
                isPremium ? (
                  <div style={{ 
                    marginTop: 24, 
                    marginBottom: 20, 
                    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', 
                    padding: '16px 20px', 
                    borderRadius: '16px', 
                    border: '1px solid #cbd5e1',
                    boxShadow: '0 4px 20px rgba(15, 23, 42, 0.03)'
                  }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: '#0f172a', marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.8px', display: 'flex', alignItems: 'center', gap: 6 }}>
                      <TagOutlined style={{ color: '#0a497b', fontSize: 14 }} /> Filter Photos by Category / Album:
                    </div>
                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
                      <button 
                        type="button"
                        onClick={() => setActiveCategoryFilter('all')}
                        style={{
                          border: activeCategoryFilter === 'all' ? '1px solid #0a497b' : '1px solid #cbd5e1',
                          background: activeCategoryFilter === 'all' ? 'linear-gradient(135deg, #0a497b 0%, #0284c7 100%)' : '#ffffff',
                          color: activeCategoryFilter === 'all' ? '#ffffff' : '#334155',
                          fontWeight: 600,
                          fontSize: 13,
                          padding: '6px 16px',
                          borderRadius: 30,
                          cursor: 'pointer',
                          transition: 'all 0.25s ease-in-out',
                          boxShadow: activeCategoryFilter === 'all' ? '0 6px 16px rgba(10, 73, 123, 0.3)' : '0 2px 6px rgba(0,0,0,0.03)',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 6
                        }}
                      >
                        All <span style={{ background: activeCategoryFilter === 'all' ? 'rgba(255,255,255,0.25)' : '#e2e8f0', color: activeCategoryFilter === 'all' ? '#ffffff' : '#475569', padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 700 }}>{gallery.length}</span>
                      </button>

                      {Array.from(new Set(gallery.map(img => img.category?.trim()).filter(Boolean))).map((catName) => {
                        const count = gallery.filter(img => img.category?.trim() === catName).length;
                        const isActive = activeCategoryFilter === catName;
                        return (
                          <button 
                            key={catName}
                            type="button"
                            onClick={() => setActiveCategoryFilter(catName)}
                            style={{
                              border: isActive ? '1px solid #0a497b' : '1px solid #cbd5e1',
                              background: isActive ? 'linear-gradient(135deg, #0a497b 0%, #0284c7 100%)' : '#ffffff',
                              color: isActive ? '#ffffff' : '#334155',
                              fontWeight: 600,
                              fontSize: 13,
                              padding: '6px 16px',
                              borderRadius: 30,
                              cursor: 'pointer',
                              transition: 'all 0.25s ease-in-out',
                              boxShadow: isActive ? '0 6px 16px rgba(10, 73, 123, 0.3)' : '0 2px 6px rgba(0,0,0,0.03)',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 6
                            }}
                          >
                            🏷️ {catName} <span style={{ background: isActive ? 'rgba(255,255,255,0.25)' : '#e2e8f0', color: isActive ? '#ffffff' : '#475569', padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 700 }}>{count}</span>
                          </button>
                        );
                      })}

                      {gallery.some(img => !img.category || !img.category.trim()) && (() => {
                        const unCatCount = gallery.filter(img => !img.category || !img.category.trim()).length;
                        const isUnCatActive = activeCategoryFilter === 'uncategorized';
                        return (
                          <button 
                            type="button"
                            onClick={() => setActiveCategoryFilter('uncategorized')}
                            style={{
                              border: isUnCatActive ? '1px solid #0a497b' : '1px solid #cbd5e1',
                              background: isUnCatActive ? 'linear-gradient(135deg, #0a497b 0%, #0284c7 100%)' : '#ffffff',
                              color: isUnCatActive ? '#ffffff' : '#334155',
                              fontWeight: 600,
                              fontSize: 13,
                              padding: '6px 16px',
                              borderRadius: 30,
                              cursor: 'pointer',
                              transition: 'all 0.25s ease-in-out',
                              boxShadow: isUnCatActive ? '0 6px 16px rgba(10, 73, 123, 0.3)' : '0 2px 6px rgba(0,0,0,0.03)',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 6
                            }}
                          >
                            Uncategorized <span style={{ background: isUnCatActive ? 'rgba(255,255,255,0.25)' : '#e2e8f0', color: isUnCatActive ? '#ffffff' : '#475569', padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 700 }}>{unCatCount}</span>
                          </button>
                        );
                      })()}
                    </div>
                  </div>
                ) : (
                  <div style={{ marginTop: 20, marginBottom: 16, background: '#f8fafc', padding: '14px 18px', borderRadius: '12px', border: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontSize: 13, fontWeight: 500, color: '#64748b', display: 'flex', alignItems: 'center', gap: 8 }}>
                      <LockOutlined style={{ color: '#d97706', fontSize: 16 }} />
                      <span><strong>Album Category Filter Tabs</strong> are available on Premium Plan.</span>
                    </div>
                    <Tooltip title="Upgrade to Premium to organize photos into custom categories & tabs!">
                      <Button size="small" style={{ fontSize: 12, borderColor: '#d97706', color: '#d97706', fontWeight: 600, borderRadius: 20 }} onClick={() => window.open(`${WEBSITE_URL}/membership-account/membership-levels/`, '_blank')}>
                        🔒 Premium Feature
                      </Button>
                    </Tooltip>
                  </div>
                )
              )}

              {/* Compact Save Rearrange Order Banner - Below Category Filter Bar */}
              {isOrderChanged && (
                <div style={{
                  background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                  border: '1px solid #7dd3fc',
                  borderRadius: '8px',
                  padding: '8px 14px',
                  marginTop: 12,
                  marginBottom: 16,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: 10,
                  boxShadow: '0 2px 8px rgba(2, 132, 199, 0.06)'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <CheckCircleFilled style={{ color: '#0284c7', fontSize: 14 }} />
                    <span style={{ fontSize: 12.5, fontWeight: 600, color: '#0369a1' }}>
                      Photo sequence rearranged! Click "Confirm Rearrange" to save changes.
                    </span>
                  </div>

                  <Button
                    type="primary"
                    size="small"
                    loading={saveLoading}
                    icon={<CheckCircleFilled style={{ fontSize: 12 }} />}
                    onClick={() => {
                      form.submit();
                    }}
                    style={{
                      background: 'linear-gradient(135deg, #0a497b 0%, #0284c7 100%)',
                      borderColor: '#0a497b',
                      borderRadius: '6px',
                      fontWeight: 600,
                      fontSize: 12,
                      height: 30,
                      padding: '0 14px',
                      boxShadow: '0 2px 6px rgba(10, 73, 123, 0.2)',
                      whiteSpace: 'nowrap',
                      cursor: 'pointer'
                    }}
                  >
                    Confirm Rearrange
                  </Button>
                </div>
              )}

              {(() => {
                const filteredGallery = gallery.filter((img) => {
                  if (activeCategoryFilter === 'all') return true;
                  if (activeCategoryFilter === 'uncategorized') return !img.category || !img.category.trim();
                  return img.category?.trim().toLowerCase() === activeCategoryFilter.toLowerCase();
                });

                // Ensure every item has a string id for dnd-kit
                const galleryWithIds = filteredGallery.map((img, i) => ({
                  ...img,
                  id: img.id || img.url || `gallery-item-${i}`
                }));

                return (
                  <div style={{ marginTop: '16px' }}>
                    {/* Uploading images - outside drag context */}
                    {uploadingImages.length > 0 && (
                      <Row gutter={[20, 20]} style={{ marginBottom: 20 }}>
                        {uploadingImages.map((img) => (
                          <Col xs={24} sm={12} md={8} key={img.tempId}>
                            <Card 
                              className="videocard-box"
                              cover={
                                <div style={{ position: 'relative', height: '220px', background: '#000', overflow: 'hidden', borderRadius: '12px' }}>
                                  <img src={img.url} alt="Uploading" style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(3px)' }} />
                                  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                    <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 48, color: '#fff' }} spin />} />
                                    <div style={{ color: '#fff', fontSize: '14px', fontWeight: '500', marginTop: '12px' }}>
                                      Uploading...
                                    </div>
                                  </div>
                                </div>
                              }
                            />
                          </Col>
                        ))}
                      </Row>
                    )}

                    {/* Drag-and-drop sortable gallery */}
                    <DndContext sensors={dndSensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                      <SortableContext items={galleryWithIds.map(g => String(g.id))} strategy={rectSortingStrategy}>
                        <Row gutter={[20, 20]}>
                          {galleryWithIds.map((img, index) => (
                            <SortableGalleryCard
                              key={String(img.id)}
                              img={img}
                              index={index}
                              isVideo={getItemMediaDetails(img).isVideo}
                              posterUrl={getItemMediaDetails(img).posterUrl}
                              isPremium={isPremium}
                              onPreview={(url) => handleImagePreview(url)}
                              onPlayVideo={(item) => handlePlayVideoModal(item)}
                              onDelete={(id) => handleRemovePhoto(id)}
                              onCategoryChange={(id, val) => setGallery(prev => prev.map(item => item.id === id ? { ...item, category: val } : item))}
                            />
                          ))}
                        </Row>
                      </SortableContext>
                    </DndContext>

                    {/* Compact Save Rearrange Banner - Bottom of Photo Grid */}
                    {isOrderChanged && (
                      <div style={{
                        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                        border: '1px solid #7dd3fc',
                        borderRadius: '8px',
                        padding: '10px 16px',
                        marginTop: 20,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 10,
                        boxShadow: '0 2px 8px rgba(2, 132, 199, 0.06)'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <CheckCircleFilled style={{ color: '#0284c7', fontSize: 15 }} />
                          <span style={{ fontSize: 13, fontWeight: 600, color: '#0369a1' }}>
                            Photo sequence rearranged! Click "Confirm Rearrange" to save changes.
                          </span>
                        </div>

                        <Button
                          type="primary"
                          size="small"
                          loading={saveLoading}
                          icon={<CheckCircleFilled style={{ fontSize: 12 }} />}
                          onClick={() => {
                            form.submit();
                          }}
                          style={{
                            background: 'linear-gradient(135deg, #0a497b 0%, #0284c7 100%)',
                            borderColor: '#0a497b',
                            borderRadius: '6px',
                            fontWeight: 600,
                            fontSize: 12.5,
                            height: 32,
                            padding: '0 16px',
                            boxShadow: '0 2px 6px rgba(10, 73, 123, 0.2)',
                            whiteSpace: 'nowrap',
                            cursor: 'pointer'
                          }}
                        >
                          Confirm Rearrange
                        </Button>
                      </div>
                    )}
                  </div>
                );
              })()}

              {/* Ant Design Interactive Gallery Lightbox Preview Group */}
              <div style={{ display: 'none' }}>
                <Image.PreviewGroup
                  preview={{
                    visible: previewGroupVisible,
                    onVisibleChange: (vis) => setPreviewGroupVisible(vis),
                    current: previewGroupIndex,
                    onChange: (current) => setPreviewGroupIndex(current)
                  }}
                >
                  {gallery.filter(item => !getItemMediaDetails(item).isVideo).map((img, i) => (
                    <Image key={img.id || i} src={img.url} alt={`Gallery photo ${i + 1}`} />
                  ))}
                </Image.PreviewGroup>
              </div>

              <Modal visible={previewVisible} title={previewTitle} footer={null} onCancel={() => setPreviewVisible(false)}>
                <img alt="Project Photo Preview" style={{ width: '100%', borderRadius: 6 }} src={previewImage} />
              </Modal>
              </div>
            </TabPane>

          </Tabs>
          
          <Form.Item className="text-end" style={{ marginTop: "30px" }}>
            <Button type="primary" htmlType="submit" className="upload-buttom" loading={saveLoading} style={{ height: "42px", padding: "0 40px", borderRadius: "6px" }}>
              Save Profile Settings
            </Button>
          </Form.Item>
        </div>
        </Form>
      )}
        </Col>
      </Row>

      {/* Inquiry View Details Modal */}
      <Modal
        title={selectedInquiry ? `Inquiry Details: ${selectedInquiry.customer_name}` : "Inquiry Details"}
        visible={inquiryModalVisible}
        onCancel={() => setInquiryModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setInquiryModalVisible(false)}>
            Close
          </Button>,
          selectedInquiry && selectedInquiry.customer_email && (
            <Button 
              key="reply" 
              type="primary" 
              onClick={() => window.open(`mailto:${selectedInquiry.customer_email}?subject=Re: ${encodeURIComponent(selectedInquiry.inquiry_type || 'Store Inquiry')}`)}
            >
              Send Email Reply
            </Button>
          )
        ]}
      >
        {selectedInquiry && (
          <div style={{ lineHeight: 1.8 }}>
            <p><strong>Customer Name:</strong> {selectedInquiry.customer_name}</p>
            <p><strong>Email:</strong> <a href={`mailto:${selectedInquiry.customer_email}`}>{selectedInquiry.customer_email}</a></p>
            <p><strong>Phone:</strong> {selectedInquiry.customer_phone ? <a href={`tel:${selectedInquiry.customer_phone}`}>{selectedInquiry.customer_phone}</a> : 'N/A'}</p>
            <p><strong>Inquiry Type:</strong> <Tag color="blue">{selectedInquiry.inquiry_type || 'General'}</Tag></p>
            <p><strong>Date Received:</strong> {selectedInquiry.created_at ? new Date(selectedInquiry.created_at).toLocaleString() : '-'}</p>
            <Divider style={{ margin: '12px 0' }} />
            <p><strong>Customer Message:</strong></p>
            <div style={{ background: '#f8fafc', padding: 12, borderRadius: 6, border: '1px solid #e2e8f0', whiteSpace: 'pre-wrap' }}>
              {selectedInquiry.customer_message}
            </div>
          </div>
        )}
      </Modal>

      {/* Luxury Add Video Link Modal */}
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingBottom: 4 }}>
            <div style={{ 
              width: 42, 
              height: 42, 
              borderRadius: '12px', 
              background: 'linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%)', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              border: '1px solid #fecaca',
              boxShadow: '0 4px 12px rgba(225, 29, 72, 0.12)'
            }}>
              <VideoCameraOutlined style={{ color: '#e11d48', fontSize: 20 }} />
            </div>
            <div>
              <div style={{ fontSize: 17, fontWeight: 700, color: '#0f172a', letterSpacing: '-0.2px' }}>
                Add Project Video
              </div>
              <div style={{ fontSize: 12, color: '#64748b', fontWeight: 400, marginTop: 2 }}>
                Embed YouTube, Vimeo, or direct MP4 video link
              </div>
            </div>
          </div>
        }
        open={videoModalVisible}
        onOk={handleAddVideoEmbed}
        onCancel={() => setVideoModalVisible(false)}
        okText="Add Video to Gallery"
        okButtonProps={{ 
          style: { 
            background: 'linear-gradient(135deg, #0a497b 0%, #0284c7 100%)', 
            borderColor: '#0a497b',
            borderRadius: 30,
            fontWeight: 600,
            padding: '6px 24px',
            height: '38px',
            boxShadow: '0 6px 18px rgba(10, 73, 123, 0.3)'
          } 
        }}
        cancelButtonProps={{
          style: {
            borderRadius: 30,
            fontWeight: 600,
            padding: '6px 20px',
            height: '38px',
            borderColor: '#cbd5e1',
            color: '#475569'
          }
        }}
        width={540}
        centered
      >
        <div style={{ padding: '16px 0 8px 0' }}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontWeight: 700, color: '#1e293b', fontSize: 13, display: 'block', marginBottom: 8 }}>
              Video Link (YouTube / Vimeo / MP4):
            </label>
            <Input 
              prefix={<VideoCameraOutlined style={{ color: '#e11d48', marginRight: 6 }} />}
              placeholder="https://www.youtube.com/watch?v=..." 
              value={videoUrlInput}
              onChange={(e) => setVideoUrlInput(e.target.value)}
              size="large"
              style={{ borderRadius: 10, fontSize: 13.5, borderColor: '#cbd5e1' }}
            />
            <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 11, background: '#fff1f2', color: '#be123c', padding: '2px 8px', borderRadius: 12, fontWeight: 600, border: '1px solid #ffe4e6' }}>🔴 YouTube</span>
              <span style={{ fontSize: 11, background: '#f0f9ff', color: '#0369a1', padding: '2px 8px', borderRadius: 12, fontWeight: 600, border: '1px solid #bae6fd' }}>🔵 Vimeo</span>
              <span style={{ fontSize: 11, background: '#f8fafc', color: '#475569', padding: '2px 8px', borderRadius: 12, fontWeight: 600, border: '1px solid #e2e8f0' }}>📼 Direct MP4</span>
            </div>
          </div>

          <div>
            <label style={{ fontWeight: 700, color: '#1e293b', fontSize: 13, display: 'block', marginBottom: 8 }}>
              Album / Category (Optional):
            </label>
            <Input 
              prefix={<TagOutlined style={{ color: '#0a497b', marginRight: 6 }} />}
              placeholder="e.g. Commercial Showroom Installations" 
              value={videoCategoryInput}
              onChange={(e) => setVideoCategoryInput(e.target.value)}
              size="large"
              style={{ borderRadius: 10, fontSize: 13.5, borderColor: '#cbd5e1' }}
            />
          </div>
        </div>
      </Modal>

      {/* Professional Video Player Modal */}
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'linear-gradient(135deg, #e11d48 0%, #be123c 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <PlayCircleFilled style={{ color: '#ffffff', fontSize: 16 }} />
            </div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#0f172a' }}>{activeVideoTitle}</div>
              <div style={{ fontSize: 11, color: '#64748b', fontWeight: 400 }}>Click close button or outside to exit player</div>
            </div>
          </div>
        }
        open={videoPlayerVisible}
        onCancel={() => setVideoPlayerVisible(false)}
        footer={[
          <Button key="close" type="primary" style={{ backgroundColor: '#0a497b', borderColor: '#0a497b', borderRadius: 6 }} onClick={() => setVideoPlayerVisible(false)}>
            Close Player
          </Button>
        ]}
        width={750}
        centered
        destroyOnClose
      >
        <div style={{ padding: '12px 0', background: '#090d16', borderRadius: 12, overflow: 'hidden', display: 'flex', justifyContent: 'center' }}>
          {(() => {
            const url = activeVideoUrl || '';
            const ytMatch = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i);
            if (ytMatch && ytMatch[1]) {
              return (
                <iframe
                  width="100%"
                  height="420"
                  src={`https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ border: 'none' }}
                />
              );
            }
            const vimeoMatch = url.match(/vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)/i);
            if (vimeoMatch && vimeoMatch[3]) {
              return (
                <iframe
                  width="100%"
                  height="420"
                  src={`https://player.vimeo.com/video/${vimeoMatch[3]}?autoplay=1`}
                  title="Vimeo video player"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  style={{ border: 'none' }}
                />
              );
            }
            return (
              <video 
                src={url} 
                controls 
                autoPlay 
                style={{ width: '100%', maxHeight: '450px', objectFit: 'contain' }} 
              />
            );
          })()}
        </div>
      </Modal>

    </div>
    </div>
  );
}

export default TrustedDealerDashboard;
